"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All filter words to filter in the ESN project
var Filter = {
  view_results: {
    nl: 'Resultaten overzicht',
    fr: 'Vue résultats',
    en: 'Results view',
    de: 'Ergebnisse anzeigen'
  },
  view_map: {
    nl: 'Kaart overzicht',
    fr: 'Vue carte',
    en: 'Map view',
    de: 'Kartenansicht'
  },
  view_on_results: {
    nl: 'Wijzig resultaten naar galerijoverzicht',
    fr: 'Modifier résultats vers galerie',
    en: 'Change results to gallery view',
    de: 'Ergebnisse zur Galerieansicht ändern'
  },
  view_on_map: {
    nl: 'Wijzig resultaten naar kaartoverzicht',
    fr: 'Modifier résultats vers maps',
    en: 'Change results to map view',
    de: 'Ergebnisse zur Kartenansicht ändern'
  },
  title_order: {
    nl: 'Sorteren op',
    fr: 'Ordre par',
    en: 'Order by',
    de: 'Sortieren nach'
  },
  title_open: {
    nl: 'Open op',
    fr: 'Ouvert le',
    en: 'Open at',
    de: 'Geöffnet am'
  },
  title_category: {
    nl: 'Toon categorie',
    fr: 'Par catégorie',
    en: 'Show category',
    de: 'Kategorie anzeigen'
  },
  btocb: {
    nl: 'Beide',
    fr: 'Les deux',
    en: 'Both',
    de: 'Beides'
  },
  filter: {
    nl: 'Filter',
    fr: 'Filtre',
    en: 'Filter',
    de: 'Filter'
  },
  sort: {
    nl: 'Sorteren',
    fr: 'Trier',
    en: 'Sort',
    de: 'Sortieren'
  },
  sort_coming_soon: {
    nl: 'Sorteren Binnnenkort mogelijk',
    fr: 'Trier bientôt possible',
    en: 'Sorting results coming soon',
    de: 'Sortieren bald verfügbar'
  },
  recent_date: {
    nl: 'Recentste datum',
    fr: 'date la plus récente',
    en: 'Most recent date',
    de: 'Neueste Datum'
  },
  oldest_date: {
    nl: 'Oudste datum',
    fr: 'Date la plus ancienne',
    en: 'Oldest date',
    de: 'Älteste Datum'
  },
  alphabetical: {
    nl: 'A - Z',
    fr: 'A - Z',
    en: 'A - Z',
    de: 'A - Z'
  },
  unalphabetical: {
    nl: 'Z - A',
    fr: 'Z - A',
    en: 'Z - A',
    de: 'Z - A'
  }
};
var _default = Filter;
exports["default"] = _default;